import React from 'react';
import classNames from 'classnames';

import { AudioPreview } from 'modules/audio';
import { IconButton } from 'modules/ui';
import { Colors } from 'modules/theme';

import { SampleDropdownOptions } from '../fragments';
import EmptySamplePlaceholder from './EmptySamplePlaceholder';
import styles from './SamplePreview.module.scss';

const PATHS = ['ageRange', 'genre', 'vertical', 'primaryLanguage'];

export default function SamplePreview({
  sample,
  index,
  onAddClick,
  paths = PATHS,
  containerClassName,
  isTalent = false,
  isReorderUi,
  onMoveSample,
  isFirstOnList,
  isLastOnList,
}) {
  const displayIndex = index + 1;
  const containerClasses = classNames(styles.container, {
    [styles.reorderContainer]: isReorderUi,
  });

  if (!sample && isTalent) {
    return (
      <EmptySamplePlaceholder
        index={displayIndex}
        onAddClick={onAddClick}
        containerClassName={containerClassName}
      />
    );
  }

  if (!sample) {
    return null;
  }

  return (
    <div className={containerClasses}>
      {isReorderUi && (
        <div className={styles.sortingIconsContainer}>
          <IconButton
            iconName="downArrow"
            isFlippedVertical
            iconColor={isFirstOnList ? Colors.darkBlue05 : Colors.grayishBlue}
            iconSize={12}
            onClick={() => !isFirstOnList && onMoveSample(sample.id, true)}
            size="large"
          />
          <IconButton
            iconName="downArrow"
            iconColor={isLastOnList ? Colors.darkBlue05 : Colors.grayishBlue}
            iconSize={12}
            onClick={() => !isLastOnList && onMoveSample(sample.id, false)}
            size="large"
          />
        </div>
      )}
      <AudioPreview
        details={sample}
        detailsPaths={paths}
        truncateLength={false}
        separator="dot"
        showTitleWhilePlaying
        informationClassName={styles.informationContainer}
      />
      {!isTalent && <SampleDropdownOptions file={sample} />}
    </div>
  );
}
